import { Box, BoxProps } from "@chakra-ui/react";
export const BookIcon = ({ ...props }: BoxProps) => {
  return (
    <Box {...props}>
      <svg
        width="11"
        height="13"
        viewBox="0 0 11 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="11" height="13" rx="1.2" fill="#1DB1C4" />
        <line
          x1="2"
          y1="3.25"
          x2="8"
          y2="3.25"
          stroke="white"
          stroke-width="1.5"
        />
        <line
          x1="2"
          y1="6.25"
          x2="6"
          y2="6.25"
          stroke="white"
          stroke-width="1.5"
        />
      </svg>
    </Box>
  );
};
